"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const color = require("color");
const styles = (theme) => (0, styles_1.createStyles)({
    centered: {
        display: 'flex',
        flex: '1',
        justifyContent: 'center'
    },
    leftAligned: {
        display: 'flex',
        flex: '1',
        justifyContent: 'left'
    },
    rightAligned: {
        display: 'flex',
        flex: '1',
        justifyContent: 'right'
    },
    body1High: Object.assign(Object.assign({}, theme.typography.body1), { color: theme.palette.text.primary }),
    body2High: Object.assign(Object.assign({}, theme.typography.body2), { color: theme.palette.text.primary }),
    body2Medium: Object.assign(Object.assign({}, theme.typography.body2), { color: theme.palette.text.secondary }),
    subtitle2High: Object.assign(Object.assign({}, theme.typography.subtitle2), { color: theme.palette.text.primary }),
    subtitleMedium: {
        color: theme.palette.text.secondary
    },
    bold: {
        fontWeight: 'bold'
    },
    dateCell: {
        minWidth: 108,
        [theme.breakpoints.down('xs')]: {
            minWidth: 65,
            maxWidth: 65
        }
    },
    earnings: {
        [theme.breakpoints.down('xs')]: {
            minWidth: 55,
            padding: theme.spacing()
        }
    },
    activityPoints: {
        minWidth: 102,
        [theme.breakpoints.down('xs')]: {
            minWidth: 55,
            maxWidth: 55
        }
    },
    description: {
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(),
            maxWidth: 85,
            minWidth: 65,
            wordWrap: 'break-word'
        }
    },
    tableRow: {
        '&:hover': {
            backgroundColor: color(theme.palette.common.black).alpha(0.1).rgb().string() + ' !important'
        }
    },
    pointsAmount: {
        minWidth: 102
    },
    rewardDetail: {
        maxWidth: 340,
        [theme.breakpoints.down('xs')]: {
            maxWidth: 55,
            padding: theme.spacing()
        }
    },
    tabSection: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    title: {
        maxWidth: 720,
        wordBreak: 'break-all',
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing()
        }
    },
    link: Object.assign(Object.assign({}, theme.typography.body2), { cursor: 'pointer', color: 'inherit', display: 'flex', alignItems: 'center', '&:focus': {
            backgroundColor: color(theme.palette.common.black).alpha(0.1).rgb().string()
        } }),
    couponLink: {
        border: '1px solid rgba(0, 87, 184, 1)',
        borderRadius: '20px',
        padding: theme.spacing(),
        color: theme.palette.primary.main,
        maxWidth: '135px',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            maxWidth: 80,
            padding: theme.spacing()
        }
    },
    couponDetail: {
        maxWidth: '135px',
        [theme.breakpoints.down('xs')]: {
            maxWidth: 80,
            padding: theme.spacing()
        }
    },
    pastHistoryLink: {
        border: '1px solid rgba(0, 87, 184, 1)',
        borderRadius: '5px',
        padding: theme.spacing(3),
        color: theme.palette.primary.main,
        maxHeight: '50px',
        textAlign: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('xs')]: {
            maxWidth: 80,
            padding: '10px'
        }
    },
    downloadIcon: {
        color: theme.palette.primary.main
    },
    underline: {
        borderBottomColor: theme.palette.text.primary,
        borderBottom: '1px solid',
        marginBottom: theme.spacing()
    },
    prizeItem: {
        marginLeft: theme.spacing()
    },
    entry: {
        borderColor: theme.palette.primary.main,
        border: '1px solid',
        paddingRight: 4,
        paddingLeft: 4
    },
    pending: {
        color: theme.palette.error.main
    },
    points: {
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column'
        }
    },
    pendingPoints: {
        marginLeft: theme.spacing(),
        marginTop: theme.spacing(),
        [theme.breakpoints.down('xs')]: {
            marginRight: theme.spacing(),
            marginLeft: 0
        }
    },
    pendingTotalPoints: {
        display: 'flex',
        flexDirection: 'row'
    },
    dialogBackdrop: {
        backgroundColor: color(theme.palette.grey[500]).alpha(0.8).rgb().string()
    },
    dialog: {
        backgroundColor: theme.palette.background.default,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3)
    },
    dialogContent: {
        padding: 0
    },
    dialogHeader: {
        marginBottom: theme.spacing(2),
        color: theme.palette.text.primary
    },
    dialogDate: {
        marginBottom: theme.spacing()
    },
    dialogImage: {
        width: 140,
        height: 140,
        marginRight: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            width: 100,
            height: 100
        }
    },
    dialogGameContent: {
        display: 'flex',
        flexDirection: 'row'
    },
    dialogGameDetails: {
        display: 'flex',
        flexDirection: 'column'
    },
    dialogGameName: {
        marginTop: theme.spacing(),
        marginBottom: theme.spacing(2)
    },
    dialogActions: {
        marginBottom: theme.spacing(3)
    },
    noBottomSpacing: {
        paddingBottom: '0 !important'
    },
    noTopSpacing: {
        paddingTop: '0 !important'
    },
    bonus: {
        display: 'inline',
        marginRight: theme.spacing(),
        verticalAlign: 'middle'
    },
    bonusPoints: {
        fontStyle: 'italic',
        display: 'inline',
        marginRight: theme.spacing()
    },
    pastHistoryBtn: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: theme.spacing(2)
    },
    pastHistoryButton: {
        padding: 0,
        '&:hover,&:focus': {
            color: `${theme.palette.primary.dark} !important`,
            backgroundColor: 'transparent !important'
        }
    },
    backButton: {
        marginBottom: theme.spacing(2),
        marginLeft: -theme.spacing(),
        '& span': {
            textTransform: 'none',
            color: theme.palette.text.secondary
        }
    },
    playButton: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        borderRadius: theme.spacing(1)
    },
    superBonus: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
    },
    superBonusText: {
        fontWeight: 'bold'
    },
    star: {
        width: 40,
        height: 40,
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    descriptionIcon: {
        display: 'inline-block',
        height: '3em',
        verticalAlign: 'middle'
    },
    clearMarginBottom: {
        marginBottom: 0
    },
    clearMarginTop: {
        marginTop: 0
    }
});
exports.default = styles;
//# sourceMappingURL=HistoryScreenStyle.js.map